var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'badge badge-' + _vm.badgeType},[(_vm.badgeType == 'success')?_c('arrow-down-icon'):_c('arrow-up-icon')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }